import React from "react"

const Prose = ({ children }) => (
  <article className="prose prose-neutral prose prose-lg max-w-none prose-red dark:prose-invert dark:prose-hr:border-neutral-600 dark:prose-tr:border-neutral-600">
    {children}
  </article>
)

export default Prose
